var _defs, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoBellOnly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 55.7"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-bell-only_svg__svg-3200797298a",
    x1: 24.2,
    x2: 29.4,
    y1: 16.4,
    y2: 2.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aeb0b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-bell-only_svg__svg-3200797298b",
    x1: 8.8,
    x2: 37.9,
    y1: 41.7,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e77709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6a700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-bell-only_svg__svg-3200797298c",
    x1: 16,
    x2: 38.3,
    y1: 72.6,
    y2: 36.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5b7ba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-bell-only_svg__svg-3200797298d",
    x1: 24.8,
    x2: 42,
    y1: 42.2,
    y2: 42.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2a4a7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-bell-only_svg__svg-3200797298a)",
    d: "M32 0h-6c-1.6 0-2.3 1.2-2.3 2.7s.7 2.7 2.2 2.7a.4.4 0 01.4.4v6.6h5.3V5.8a.4.4 0 01.4-.4c1.5 0 2.2-1.2 2.2-2.7S33.5 0 32 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-bell-only_svg__svg-3200797298b)",
    d: "M0 39.1a29 29 0 0158 0v.7H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-bell-only_svg__svg-3200797298c)",
    d: "M53.6 44.6H4.2A4.2 4.2 0 000 48.7v7h57.8v-7a4.2 4.2 0 00-4.2-4.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-bell-only_svg__svg-3200797298d)",
    d: "M22.9 39.8h11.9v4.7H22.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8f5ed",
    d: "M6.1 34.1c3.3-12.1 10-17.3 16.9-18 0 0-8.3 4.8-8.3 18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-bell-only_svg__svg-3200797298b)",
    d: "M0 39.1a29 29 0 0158 0v.7H0z",
    opacity: 0.4
  })));
}

export default SvgLogoBellOnly;